import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, EMPTY, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SocoHttpService } from '@soco/http';
import { SocoConfigurationService } from '@soco/configuration';

import { ApiResult } from '@soco/core';
import { url } from 'inspector';
import {  AvailabilityRequest } from './availability-selection-entities';

@Injectable()
export class AvailabilityService {

    public baseUrl = '/Reschedule/';
    public appDataBaseUrl = '/AppData/';
    public account: any = {};
    
    constructor(private http: SocoHttpService, private ngHttp: HttpClient, private config: SocoConfigurationService) { }

    getAvailability(availabilityRequest: AvailabilityRequest) {

        //console.log('availability params : ', availabilityRequest);

        return this.http.post<any>({
            url: this.baseUrl + 'GetRescheduleAvailability',
            data: availabilityRequest,
            shouldIgnoreInvalidResult: true,
            pleaseWaitTimeoutDuration: 500            
        });
    }

    getRescheduleEligibility(ldc: string, orderNumber: string, premisesNumber: string, scheduleDate: string) {
        var params: string= '';

        if (scheduleDate == null || scheduleDate == '')
            scheduleDate = 'NA';

        if (orderNumber != null && orderNumber != '')
            params = ldc + "/" + orderNumber + "/" + scheduleDate;
        
        if (premisesNumber != null && premisesNumber != '')
            params = params + "/" + premisesNumber

        //console.log('eligibility params : ', params);
        
        return this.http.get<any>({
            url: this.baseUrl + 'GetRescheduleEligibility/' + params,            
        });
    }
    
    // Error call back for http requests.
    private handleError(error: any) {

        // const errMsg = (error.message) ? error.message :
        //   error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        // return Observable.throw(errMsg);
    }

}
